<template>
  <el-select v-if="disabled === true" class="el-select" disabled v-model="selectValue" @change="valueChange">
    <el-option width="200px" class="a" v-for="(item, index) in options" :key="'select' + index" :value="item.value" :label="item.label"></el-option>
  </el-select>
  <el-select v-else class="el-select" v-model="selectValue" clearable @change="valueChange">
    <el-option width="200px" v-for="(item, index) in options" :key="'select' + index" :value="item.value" :label="item.label"></el-option>
  </el-select>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'SelectDictionary',
  props: {
    dicName: {
      type: String,
      default: ''
    },
    idProperty: {
      type: String,
      default: ''
    },
    pidProperty: {
      type: String,
      default: ''
    },
    displayProperty: {
      type: String,
      default: ''
    },
    dictionaryFilterScript: {
      type: String,
      default: ''
    },
    value: {
      default: ''
    },
    disabled: {
      default: false
    },
    isQuote: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      selectValue: 'xxx'
    }
  },
  created() {
    console.log('2' + this.value + this.selectValue)
    request({
      url: `/dictionary/tree${this.isQuote ? '/quote' : ''}`,
      method: 'get',
      params: {
        entityName: this.dicName,
        idProperty: this.idProperty,
        pidProperty: this.pidProperty,
        displayProperty: this.displayProperty,
        dictionaryFilterScript: this.dictionaryFilterScript
      }
    }).then(response => {
      this.options = response.data
    })
  },
  mounted() {
    console.log('3' + this.value + this.selectValue)
  },

  methods: {
    valueChange(selectValue) {
      this.$emit('input', selectValue)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.selectValue = value
      }
    }
  }
}
</script>

<style scoped>
.a {
  border: none;
}
.el-select {
  width: 100%;
}
</style>
